import { css } from 'styled-components';

export const SupportButtonStyled = css`
    .support-button {
        position: absolute;
        bottom: 20px;
        left: 20px;

        width: 48px;
        height: 48px;
        border-radius: 50%;

        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.06), 0 2px 32px 0 rgba(0, 0, 0, 0.16);

        cursor: pointer;
        transition: transform 167ms cubic-bezier(0.33, 0.00, 0.00, 1.00);
        
        overflow: hidden;
        -webkit-font-smoothing: antialiased;
    }

    .support-button:hover {
        transform: scale(1.1);
    }

    .ant-float-btn-default .ant-float-btn-body {
        background-color: #0aa89a !important;
    }

    .ant-float-btn-content {
        align-items: center !important;
    }

    .ant-float-btn-icon {
        width: auto !important;
    }
`;
